module.exports = __webpack_public_path__ + "img/ThumbsUpIcon.a4f2bbff.svg";